module.exports = __webpack_public_path__ + "static/media/wowza-logo.c9001ef3.svg";